export default __webpack_public_path__ + "static/media/servicoQuarto.de703163.svg";